import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AuthGate from "@/components/AuthGate";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Review from "@/pages/Review";
import Quotes from "@/pages/Quotes";
import QuoteDetail from "@/pages/QuoteDetail";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Schedule from "@/pages/Schedule";
import DayPlans from "@/pages/DayPlans";
import DayPlanDetail from "@/pages/DayPlanDetail";
import PackingLists from "@/pages/PackingLists";
import PackingListDetail from "@/pages/PackingListDetail";
import Settings from "@/pages/Settings";
import WorkshopView from "@/pages/WorkshopView";
import WorkshopDay from "@/pages/WorkshopDay";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public workshop links — bypass the password gate */}
          <Route
            path="/workshop/day/:date/:token"
            element={<WorkshopDay />}
          />
          <Route
            path="/workshop/:quoteId/:token"
            element={<WorkshopView />}
          />
          {/* Everything else is gated */}
          <Route
            path="/*"
            element={
              <AuthGate>
                <Routes>
                  <Route element={<Layout />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/review" element={<Review />} />
                    <Route path="/quotes" element={<Quotes />} />
                    <Route path="/quotes/:id" element={<QuoteDetail />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/customers/:name" element={<CustomerDetail />} />
                    <Route path="/schedule" element={<Schedule />} />
                    <Route path="/day-plans" element={<DayPlans />} />
                    <Route path="/day-plans/:date" element={<DayPlanDetail />} />
                    <Route path="/packing-lists" element={<PackingLists />} />
                    <Route path="/packing-lists/:date" element={<PackingListDetail />} />
                    <Route path="/settings" element={<Settings />} />
                  </Route>
                </Routes>
              </AuthGate>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="light" />
    </div>
  );
}

export default App;
